import React from "react";
import { ExchangePayment, PaymentFinal } from "../Components";
import { useAppContext } from "../contexts";

export const ExPayment = () => {
  const { isShowFinalPayment } = useAppContext();
  return isShowFinalPayment ? <PaymentFinal /> : <ExchangePayment />;
};
